
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { EscalateForm } from '@/services/QC-V2/escalation/forms/EscalateForm';
import {
  EscalationPriority,
  EscalationPriorityInterface,
  EscalationStatus, TicketEscalationCreateData,
} from '@/services/QC-V2/escalation/interfaces';
import { UserBaseInfoInterface, UserRepoInterface } from '@/services/Users/Interfaces';
import { TicketInterface } from '@/services/QC-V2/ticket/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'userRepository',
  ],
})
export default class TicketEscalateDialog extends Vue {
  @Prop() private ticket!: TicketInterface;

  private loading: boolean = true;
  private visible: boolean = true;

  private userRepository!: UserRepoInterface;

  private form: WPXFormValue<EscalateForm> = new WPXFormValue(EscalateForm);

  private departmentManagers: UserBaseInfoInterface[] = [];
  private shiftManagers: UserBaseInfoInterface[] = [];
  private priorities: EscalationPriorityInterface[] = [];

  private async created(): Promise<void> {
    try {
      await this.initialize();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(
        e.response?.data?.message ? e.response.data.message : e.message,
      );
    }
  }

  private async initialize(): Promise<void> {
    await this.fetchUsers();
    await this.fetchPriorities();
  }

  private async fetchUsers(): Promise<void> {
    this.departmentManagers = await this.userRepository.getQaManagers();
    this.shiftManagers = await this.userRepository.getShiftManagers();
  }

  private fetchPriorities(): void {
    Object.keys(EscalationPriority).forEach((key, index) => {
      this.priorities.push({ key, value: Object.values(EscalationPriority)[index] });
    });
  }

  private async escalate(): Promise<void> {
    const data: TicketEscalationCreateData = {
      ticketId: this.ticket.id,
      escalatedFrom: this.$store.getters.id,
      departmentManager: this.form.data.departmentManager !== '' ? this.form.data.departmentManager : undefined,
      shiftManager: this.form.data.shiftManager ? this.form.data.shiftManager : undefined,
      reason: this.form.data.reason,
      priority: this.form.data.priority,
      status: EscalationStatus.OPEN,
    };

    this.$emit('create-escalation', data);
    this.destroyComponent();
  }

  private validateForm(): void {
    const shiftManagerSelected = (!!this.form.data.shiftManager && !!this.form.data.shiftManager.length);
    const departmentManagerSelected = (!!this.form.data.departmentManager && !!this.form.data.departmentManager.length);
    const hasReason = !!this.form.data.reason.length;
    const hasPriority = !!this.form.data.priority.length;

    if ((shiftManagerSelected || departmentManagerSelected) && hasReason && hasPriority) {
      this.form.valid = true;
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
